import flex from "../../styles/flex";
import palette from "../../styles/palette";
import position from "../../styles/position";

export default {
    rootContainer: {
        ...position.fixedFill
    } as React.CSSProperties,
    rootContainerRelative: {
        ...position.relativeFill
    } as React.CSSProperties,
    rootContainerLayout: {
        ...flex.flexRows,
        height: "100%"
    } as React.CSSProperties,
    mainContainer: {
        ...flex.flexFill,
        height: "100%",
    } as React.CSSProperties,

    mainContainerFlex: {
        ...flex.flexColumns,
        height: "100%"
    } as React.CSSProperties,
    pageWrapper: {
        ...position.relativeFill,
        backgroundColor: palette.bg.secondary
    },
    pageContainer: {
        ...position.absoluteFill,
        overflowY: "scroll",
    } as React.CSSProperties,
    pageContainerNoScroll: {
        ...position.absoluteFill,
    } as React.CSSProperties,

    navBar: {
        borderRight: `solid 1px ${palette.border.primary}`,
        ...flex.flexAuto,
        overflow: "auto"
    } as React.CSSProperties,
    navBarSpacer: {
        position: "absolute",
        left: 0
    } as React.CSSProperties,
    searchMask: {
        ...position.absoluteFill,
        backgroundColor: "black",
        opacity: 0.7
    } as React.CSSProperties,
};
